<template>
  <accounting-mutation>
    <template v-slot="{ isSaving, syncInvoiceToProvider, deleteInvoice }">
      <finance-tracker-document-popover
        :documents="invoices"
        :fn-delete="deleteInvoice"
        :fn-sync="syncInvoiceToProvider"
        @change="$emit('change')"
      >
        <slot />
      </finance-tracker-document-popover>
    </template>
  </accounting-mutation>
</template>
<script>
import AccountingMutation from '@/components/Mutations/Admin/AccountingMutation';
import FinanceTrackerDocumentPopover from '@/components/Admin/Accounting/FinanceTracker/FinanceTrackerDocumentPopover';

export default {
  components: { AccountingMutation, FinanceTrackerDocumentPopover },
  props: {
    invoices: {
      type: Array,
      required: true
    }
  }
};
</script>
